
const styles = (theme) => ({
  ...theme.global,
  box: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '90vh',
  }
})
export default styles
